module.exports = __webpack_public_path__ + "static/media/salto-icon.8caab728.png";